import { ProviderRole } from '@bariendo/lib/constants';

// Role colors for team / individual avatars (BAR-2571).
//
// Five groups, one color each, from the design system's ROLE palette
// (everself-design-system → 01-foundation/tokens/color → "Role palette
// (5 — INTERNAL ONLY)"). This is a second internal set, deliberately NOT the
// categorical palette: those seven hues already mean activity types on the
// timeline spine and offerings on the procedure pill, and an avatar sitting
// next to a marker must not look like a sixth marker.
//
// The role set is the deeper register — darker, inkier, with hues placed in
// the gaps between the categorical hues — so both sets read as one family
// while never being mistaken for each other. All five pass WCAG AA with Warm
// White text, so there is no per-color text rule to remember.
//
//   PAC + PN   Brick    #A3432F   --ev-color-role-brick    the front door
//   CC + CM    Plum     #7A3A70   --ev-color-role-plum     coordination
//   NP         Pine     #2B6652   --ev-color-role-pine     clinical consult
//   RD         Olive    #5F6E2A   --ev-color-role-olive    nutrition
//   MD + MD-S  Indigo   #3E4C9B   --ev-color-role-indigo   physician
//
// Team avatars take the color as a solid fill; individual avatars take it as a
// 2px ring around the usual Dark Green tint.

export interface RoleColor {
  fill: string;
  text: string;
}

const WARM_WHITE = '#FAFCF7';

const BRICK: RoleColor = { fill: '#A3432F', text: WARM_WHITE };
const PLUM: RoleColor = { fill: '#7A3A70', text: WARM_WHITE };
const PINE: RoleColor = { fill: '#2B6652', text: WARM_WHITE };
const OLIVE: RoleColor = { fill: '#5F6E2A', text: WARM_WHITE };
const INDIGO: RoleColor = { fill: '#3E4C9B', text: WARM_WHITE };

export const ROLE_COLORS: Partial<Record<ProviderRole, RoleColor>> = {
  [ProviderRole.PATIENT_ACCESS]: BRICK,
  [ProviderRole.PATIENT_NAVIGATOR]: BRICK,
  [ProviderRole.PATIENT_COORDINATOR]: PLUM,
  [ProviderRole.CARE_MANAGER]: PLUM,
  [ProviderRole.NURSE_PRACTITIONER]: PINE,
  [ProviderRole.REGISTERED_DIETITIAN]: OLIVE,
  [ProviderRole.PHYSICIAN]: INDIGO,
  [ProviderRole.SUPERVISING_PHYSICIAN]: INDIGO,
};

/** Color pair for a role, or undefined for roles outside the five groups (admin, BE, EQA). */
export function getRoleColor(role: ProviderRole | undefined): RoleColor | undefined {
  return role ? ROLE_COLORS[role] : undefined;
}
